import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import './Country.css';

const url = process.env.REACT_APP_BACKEND_URL;

const EditCountry = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);

  const [data, setData] = useState({
    name:""
  });

  useEffect(()=>{

    const fetchCountry = async ()=>{

      try{

        const response = await axios.get(`${url}/api/country/${id}`);

        setData({
          name: response.data.data.name
        });

      }catch(error){

        toast.error("Failed to load Country data");

        navigate('/ViewCountry');

      }

    };

    fetchCountry();

  },[id]);

  const handleSubmit = async(e)=>{

    e.preventDefault();

    setSubmitting(true);

    try{

      const response = await axios.put(
        `${url}/api/country/${id}`,
        data
      );

      if(response.data.success){

        toast.success("Country updated successfully!");

        navigate('/ViewCountry');

      }

    }catch(error){

      toast.error(error.response?.data?.message || "Failed to update Country");

    }finally{

      setSubmitting(false);

    }

  };

  const handleChange = (e)=>{

    const {name,value} = e.target;

    setData(prev => ({...prev,[name]:value}));

  };

  return (

    <div className="form-wrapper">

      <div className="country-form-container">

        <h2 className="form-title">
          <Globe size={20}/> Edit Country
        </h2>

        <form className="country-form" onSubmit={handleSubmit}>

          <div className="form-field filled">

            <input
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
              required
            />

            <label>Country Name</label>

          </div>

          <div style={{display:'flex',gap:'10px'}}>

            <button
              type="button"
              className="cancel-btn"
              onClick={()=>navigate('/ViewCountry')}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="submit-btn"
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Country"}
            </button>

          </div>

        </form>

      </div>

    </div>

  );

};

export default EditCountry;